module.exports = __webpack_public_path__ + "media/images/common/ico-user-f1b19b93f7e0e48abb90dcde62deea7b.svg";